// PeanutsPage.js
import React, { useState } from "react";
import "./OnionPage.css"; // Include styling here or in a separate file
import { EnquiryForm } from "./EnquiryForm"; // Ensure EnquiryForm is defined elsewhere
import productimg1 from "../../assets/img/PINK_ONION.jpg"


const productData = [
  {
    id: 1,
    title: "Onion Page",
    description: "Premium quality Onion Page for various uses.",
    image: productimg1, // Replace with actual image paths
    specifications: {
      Grade: "A Grade",
      OnionSize: "45mm, 50, 55mm, 60mm, 65mm, 70mm",

      Packing: "25/40 Kg Jute / Mesh Bag",
      Origin: "Nasik, India",

    },
  },

];

export const OnionPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };
  const handleShareClick = () => {
    const textToShare = encodeURIComponent(
      'Check out this awesome link: https://example.com'
    );
    const whatsappUrl = `whatsapp://send?text=${textToShare}`;
    window.location.href = whatsappUrl;
  };
  const phoneNumber = '9926122299'; // Replace with the desired phone number
  const message = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

  // WhatsApp API URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <section className="product-page-section">
      <div className="product-page-container">
        {productData.map((product) => (
          <div key={product.id} className="singleproduct-card">
            {/* Product Image */}
            <div className="singleproduct-image">
              <img src={product.image} alt={product.title} />
            </div>

            {/* Product Content */}
            <div className="singleproduct-content">
              <h1>{product.title}</h1>
              <p>{product.description}</p>

              {/* Product Specifications */}
              <table className="singleproduct-specs-table">
                <thead>
                  <tr>
                    <th>Specification</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(product.specifications).map(
                    ([key, value], index) => (
                      <tr key={index}>
                        <td>{key}</td>
                        <td>{value}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>

              {/* Action Buttons */}
              <div className="product-action-buttons">
              <button className="request-a-call">
                                    <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
                                                     <i className="fas fa-phone"></i> Send whatsapp
                                    </a>
                                </button>
                <button className="send-enquiry" onClick={openForm}>
                  <i className="fa fa-envelope"></i> Send Enquiry
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Enquiry Form */}
        {isFormOpen && <EnquiryForm onClose={closeForm} />}
      </div>
    </section>
  );
};
